import { appConstants } from "../_constants";
import { getLang } from "../_helpers/language";

const initialState = {
  page: "confs",
  // Язык кабинета до первого входа: тот же getLang, что у публичных страниц.
  // Здесь стоял хардкод «ru», из-за чего в китайской сборке экран логина был
  // китайским, а сразу после входа кабинет становился русским — и этот же «ru»
  // уходил в N-Fixed-Locale, так что бэкенд навсегда записывал русскую локаль
  // в профиль нового пользователя.
  lang: getLang(),
  // Вкладка настроек для программного перехода (ссылка «Пополните баланс» из
  // ограничений мероприятия): SettingsPage читает её при монтировании и сбрасывает.
  // null — обычный вход через меню.
  settingsTab: null,
};

export function app(state = initialState, action) {
  if (action.type === appConstants.UPDATE_API_HOST) {
    return {
      ...state,
      apiHost: action.host,
    };
  }
  if (action.type === appConstants.SET_MENU) {
    return {
      ...state,
      page: action.page,
    };
  }
  if (action.type === appConstants.SET_LANG) {
    return {
      ...state,
      lang: action.lang,
    };
  }
  if (action.type === appConstants.SET_SETTINGS_TAB) {
    return {
      ...state,
      settingsTab: action.tab,
    };
  }

  return state;
}
